module.exports = __webpack_public_path__ + "static/img/avatar.9fcee095.png";